<div class="sitemap sitemap-wrapper" *ngIf="siteMapResponse">
  <div class="container">
    <h1> Sitemap</h1>
    <ng-container *ngIf="siteMapData  && siteMapData.length > 0">
      <ul class="listing d-flex flex-wrap">
        <li *ngFor="let siteMap of siteMapData"><a [href]="siteMap['C']" target="_blank">{{siteMap &&
            siteMap['B']?siteMap['B']:""}}</a></li>
      </ul>
    </ng-container>
  </div>
</div>